module.exports = __webpack_public_path__ + "img/beer_id-42.368d869c.png";